import { createContext, useContext, useState, useEffect } from 'react';
import { userApi } from '../api/client';
import { Purchases } from '@revenuecat/purchases-capacitor';

const AuthContext = createContext(null);

export function AuthProvider({ children, autoLoadUser = true }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (autoLoadUser) {
      loadUser();
    } else {
      setLoading(false);
    }
  }, []);

  async function loadUser() {
    try {
      const res = await userApi.getInfo();
      if (res.success) {
        setUser(res.data);
        // 用户登录成功后，关联 RevenueCat 用户
        if (res.data.id && typeof window !== 'undefined' && 'Capacitor' in window) {
          try {
            console.log("登录之后拿到的数据",res.data);
            await Purchases.logIn({appUserID:String(res.data.id)});
          } catch (e) {
            console.warn('RevenueCat 登录关联失败', e);
          }
        }
        return true;
      }
    } catch (err) {
      // 401 错误表示用户未登录，这是预期行为，不显示错误
      if (err.response?.status !== 401) {
        console.error('加载用户信息失败', err);
      }
    } finally {
      setLoading(false);
    }
    return false;
  }

  async function updateProfile(updates) {
    setUser(prev => ({ ...prev, ...updates }));
  }

  // 清除用户状态（退出登录时调用）
  async function logout() {
    // 退出 RevenueCat
    if (typeof window !== 'undefined' && 'Capacitor' in window) {
      try {
        await Purchases.logOut();
      } catch (e) {
        console.warn('RevenueCat 登出失败', e);
      }
    }
    setUser(null);
  }

  const value = {
    user,
    loading,
    updateProfile,
    refresh: loadUser,
    logout,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth 必须在 AuthProvider 内部使用');
  }
  return context;
}
